import React from 'react';
import { AnimationContainer, LoaderContainer } from './styles';
import { useLottie } from 'lottie-react';
import loadingAnimation from './../../assets/animation/loading.json';

const MailTockLoader = () => {
  const options = {
    animationData: loadingAnimation,
    loop: true,
  };

  const { View } = useLottie(options);

  return (
    <LoaderContainer>
      <AnimationContainer>{View}</AnimationContainer>
    </LoaderContainer>
  );
};

export default MailTockLoader;
